import { BulkActionWrapperDialogProps, BulkActionDialog } from 'components/core/bulk-actions/BulkActionDialog'
import { C1LabeledTextFieldWithPresets } from 'components/core/RHKFormComponents/C1LabeledTextFieldWithPresets'
import { getRemovePresets } from 'components/pages/task/action/messages'
import { AppEntitlementUserBindingSearchFilter } from 'pbts/c1/api/app/v1/app_entitlement'
import { AppEntitlementUserBindingRef } from 'pbts/c1/api/app/v1/app_refs'
import { FC, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

type BulkCreateRevokeTasksDialogProps<T extends AppEntitlementUserBindingRef> = BulkActionWrapperDialogProps<T>

export const BulkCreateRevokeTasksDialog = <T extends AppEntitlementUserBindingRef>(): FC<BulkActionWrapperDialogProps<T>> => {
    return (props) => <BulkCreateRevokeTasksDialogInner<T> {...props} />
}
function BulkCreateRevokeTasksDialogInner<T extends AppEntitlementUserBindingRef>({
    close,
    selections,
    setSelections,
    triggerFetchActionStatus,
}: BulkCreateRevokeTasksDialogProps<T>): React.ReactNode {
    const intl = useIntl()
    const [reason, setReason] = useState<string>('')

    return (
        <BulkActionDialog<T>
            size="sm"
            close={close}
            args={{
                oneofKind: 'createRevokeTicketsAction',
                createRevokeTicketsAction: {
                    filter: AppEntitlementUserBindingSearchFilter.create({
                        refs: selections.map((appEntWithUser) => ({
                            appId: appEntWithUser.appId,
                            appEntitlementId: appEntWithUser.appEntitlementId,
                            appUserId: appEntWithUser.appUserId,
                        })),
                    }),
                    reason,
                },
            }}
            selections={selections}
            setSelections={setSelections}
            title={
                <FormattedMessage
                    id="bulk_action_revoke_tasks_title"
                    defaultMessage="Create revocation tasks for {count} {count, plural, one {grant} other {grants}}"
                    values={{ count: selections.length }}
                />
            }
            submitButtonText={<FormattedMessage id="bulk_action_revoke_tasks_submit" defaultMessage="Revoke" />}
            triggerFetchActionStatus={triggerFetchActionStatus}
        >
            <C1LabeledTextFieldWithPresets
                label={intl.formatMessage({
                    id: 'bulk_revoke_tasks_reason',
                    defaultMessage: 'Reason for revoking access',
                })}
                placeholder={intl.formatMessage({
                    id: 'bulk_revoke_tasks_reason_placeholder',
                    defaultMessage: 'Why are you revoking access?',
                })}
                fullWidth
                name="reason"
                presets={getRemovePresets(intl)}
                setValue={setReason}
                value={reason}
                onChange={(e): void => setReason(e.target.value)}
                autoFocus
            />
        </BulkActionDialog>
    )
}
